function HeaderLine() {
    return (
        <div className='hidden lg:block lg:border flex-1 h border-grey2 self-center mx-10'></div>
    )
}

export default HeaderLine;